export default __webpack_public_path__ + "static/media/fenix-logo.f17ea57e.svg";